import type { ReactNode } from 'react';
import { type FC } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import type { SxProps, Theme } from '@mui/material/styles';
import { StyledTableCell } from '@/components/boxes/BoxTools.tsx';

export const CollapsibleTableRow: FC<{
  contentCell: ReactNode;
  visibilityCell: ReactNode;
  beingEditedCell?: ReactNode;
  testId?: string;
  hover?: boolean;
  sx?: SxProps<Theme>;
}> = ({ contentCell, visibilityCell, beingEditedCell, testId, hover, sx }) => {
  return (
    <TableRow
      sx={{
        '& td': {
          paddingRight: 0.5,
          paddingLeft: 1,
          paddingTop: 0,
          paddingBottom: 0
        },
        '&:hover button.locate-button': {
          opacity: 1,
          color: 'primary.main'
        },
        '& button.locate-button': { opacity: 0.1 },
        ...sx
      }}
      data-testid={testId}
      hover={hover}
    >
      <TableCell component="td" scope="row">
        {contentCell}
      </TableCell>
      {beingEditedCell !== undefined && (
        <StyledTableCell component="td" scope="row" align={'right'} className={'limited-width'}>
          {beingEditedCell}
        </StyledTableCell>
      )}
      <StyledTableCell component="td" scope="row" align={'right'} className={'limited-width'}>
        {visibilityCell}
      </StyledTableCell>
    </TableRow>
  );
};
